import { ASSET_TYPE } from '@24i/nxg-sdk-photon/src/enums';
import { MapTriggerFunction, TealiumResultPayload } from '../types';

export const mapPlayer: MapTriggerFunction = (
    _triggerName,
    payload,
    _dataMapper
): TealiumResultPayload => {
    const asset = payload.payload.asset || payload.payload.params?.asset;
    if (!asset) return {};
    const { type, title, duration: assetDuration } = asset;
    const { duration, currentPlaybackTimeMs } = payload.payload;
    const isLive = type === ASSET_TYPE.CHANNEL;
    return {
        video_name: title || '',
        video_length: duration > 0 ? duration / 1000 : assetDuration || 0,
        video_position: currentPlaybackTimeMs / 1000,
        media_type: isLive ? 'live' : 'vod',
    };
};
